<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" [classtype]="'bluehead'" mat-dialog-title>
</app-layout-dialogheader1>

<mat-dialog-content>
    <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
    <form [formGroup]="myform">
        <div class="container-fluid">
            <p class="form-hint">Fields with * are required</p>
            <ng-container *ngIf="layerNameEditable">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="name">* Layer name </label>
                    <div class="col-sm-9">
                        <input class="form-control form-control-sm" id="name" formControlName="name" type="text"
                            required placeholder="Enter layer name"
                            [ngClass]="!myform.get('name').valid ? 'is-invalid' :'' ">
                        <div class="invalid-feedback" *ngIf="myform.get('name').hasError('required')">
                            Name is required
                        </div>
                        <div class="invalid-feedback" *ngIf="myform.get('name').hasError('minlength')">
                            Name must be at least 3 characters long.
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!layerNameEditable">
                <div class="form-group row">
                    <label class="col-sm-3 col-form-label" for="name">Layer name </label>
                    <div class="col-sm-9">
                        <input class="form-control form-control-sm" id="name" formControlName="name" type="text"
                            placeholder="Enter layer name" readonly>
                    </div>
                </div>
            </ng-container>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="name">File</label>
                <div class="col-sm-9">
                     <file-choose-control #layerfilecontrol [acceptFilter]="acceptFilter" [fileMessagePlaceholder]="'Choose file with GeoData'"
                        (fileSelectedEvent)="fileSelectedEventHandler($event)">   
                        <h6></h6>         
                    </file-choose-control>
                    <div class="input-hint">Select file based on Geographical Coordinate System (EPSG:4326)</div>  
                </div>
            </div>
            <!-- PanelType -->
            <div class="form-group row">

                <div class="col-sm-3 ">
                    <label class="col-form-label" for="panelType_name">Panel type
                    </label>
                </div>
                <div class="col">
                    <div class="input-group input-group-sm">
                        <input class="form-control form-control-sm withpointer" id="panelType_name"
                            formControlName="panelType_name" type="text" placeholder="Select new panel type if needed"
                            readOnly matTooltip="Click to edit" (click)="selectPanelType()">
                        <div class="input-group-append">
                            <button class="btn" (click)="selectPanelType()">Edit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="okaction()" [disabled]="!isvalid()"
        class="btn btn-success pull-right">Upload</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>